import {AutoComplete, DatePicker, Form, Input, InputNumber, Select} from "antd";
import {FormInstance} from "antd/lib/form/Form";
import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import type {InputRef} from "antd";
import {FIELD_TYPE, FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import dayjs from "dayjs";
import {useAppSelector} from "redux/hooks";
import {pharmacyStoreService, catalogService, storeService} from "api";
import moment from "moment";
import {toNumber} from "helper/common";

import {Rule} from "antd/es/form";
import Notification from "components/common/notification/notification";
type EditableRowProps = {
  index: number;
};
const {COMBO_BOX, CURRENCY, CODE} = FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  initRules?: Rule[];
  hidden?: boolean;
  autoFocus?: boolean;
  form?: any;
  setTongTien?: any;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  return (
    <>
      <tr {...props} />
    </>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  form,
  autoFocus,
  setTongTien,
  initRules,
  ...restProps
}) => {
  const [newOptions, setNewOptions] = useState([]);

  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const setFieldValue = (dataIndex: string, value: any) => {
    form?.setFieldValue([name, index, dataIndex], value);
  };
  const getFieldValue = (dataIndex: string) => {
    return form?.getFieldValue([name, index, dataIndex]);
  };
  useEffect(() => {
    if (name == "listBranch") {
      setNewOptions(
        options?.map(e => ({value: e?.id?.toString(), label: e?.description}))
      );
    }

    if (
      name == "listKhoDuoc" ||
      name == "listKhoKinh" ||
      name == "listKhoVT" ||
      name == "listRole"
    ) {
      setNewOptions(
        options?.map(e => ({value: e?.id?.toString(), label: e?.name}))
      );
    }
  }, []);
  let childNode = children;

  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          open={openDropdown}
          onFocus={() => {
            setOpenDropdown(true);
          }}
          onBlur={() => {
            setOpenDropdown(false);
          }}
          onSelect={() => {
            setOpenDropdown(false);
          }}
          placeholder={disabled ? "--" : "Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={e => {}}
          onClick={async e => {}}
          // labelInValue={true}
          {...restProps}
        />
      </Form.Item>
    );
  }

  if (type == CURRENCY) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {}}
          placeholder={!disabled ? "Nhập" : ""}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
